import { ProjectWithMetadata } from "@nova/constants"
import { PDFJob } from "@nova/protobuf"

export const pdfTransformer = (pdf: PDFJob, project: ProjectWithMetadata) => {
    return {
        pdfPath: () => {
            return `public/org/${project.orgId}/job/${pdf.id}/output/map.pdf`
        },
        entity: pdf,
        project,
    }
}
